<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Stores
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <v-text-field
                v-model="data.id_number"
                outlined
                label="GST Number"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.gst_no"
              ></v-text-field>
            </v-col>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="user"
                outlined
                v-model="form.state_id"
                :items="stateItems"
                label="States"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.state_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="3">
              <v-text-field
                v-model="form.business_name"
                outlined
                label="Business Name*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.business_name"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_type"
                :items="statuses"
                label="Store*"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.store_type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.state_jurisdiction"
                outlined
                label="State Name*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.state_jurisdiction"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                ref="city"
                outlined
                v-model="form.city"
                :items="cityItems"
                label="City*"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.city"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.pincode"
                outlined
                label="Pincode"
                prepend-inner-icon="mdi-mailbox"
                type="number"
                :error-messages="errors.pincode"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.store_location"
                outlined
                label="Location*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.store_location"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.toll_free"
                outlined
                label="Toll Free Number*"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.toll_free"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.store_code"
                outlined
                label="Store Code*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.store_code"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                outlined
                v-model="form.owner_id"
                :items="frachiseeItems"
                label="Franchisee"
                prepend-inner-icon="mdi-account"
                clearable
                :error-messages="errors.owner_id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="end">
            <v-col sm="5">
              <v-textarea
                v-model="form.address"
                outlined
                label="Address*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.address"
              ></v-textarea>
            </v-col>
            <v-col sm="5" v-if="showNewAddress || form.new_address">
              <v-textarea
                v-model="form.new_address"
                outlined
                label="New Address*"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.new_address"
              ></v-textarea>
            </v-col>
            <v-col sm="2">
              <v-checkbox
                v-model="showNewAddress"
                label="Add New Address"
                class="mb-3"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <div>
            <span class="text-h6 ml-3">Add of Salesman</span>
          </div>
          <v-col sm="4">
            <v-autocomplete
              ref="user"
              outlined
              v-model="form.user_ids"
              :items="userItems"
              label="Salesman"
              multiple
              prepend-inner-icon="mdi-account"
              deletable-chips
              small-chips
              clearable
              :error-messages="errors.user_id"
            ></v-autocomplete>
          </v-col>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Stores
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreCreatePage",
  data() {
    return {
      data: {
        key: "133c4c48-e4cd-439a-a3c8-9a8a440390ff",
        id_number: "",
        filing_status_get: true,
      },
      form: {
        business_name: "",
        store_location: "",
        state_jurisdiction: "",
        address: "",
        new_address: "",
        city: "",
        pincode: "",
        toll_free: "",
        email: "",
        owner_id: "",
        user_ids: [],
        store_users: [],
      },
      isLoading: false,
      userItems: [],
      frachiseeItems: [],
      cityItems: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "COMPANY OWNER", text: "COMPANY OWNER", value: 1 },
        { id: "FRANCHISEE", text: "FRANCHISEE", value: 2 },
      ],
      showNewAddress: false,
    };
  },
  watch: {
    "data.id_number"(newVal) {
      // Check if GST number length is 15
      if (newVal.length === 15) {
        this.getData(); // Call the get data function
      }
    },
    "form.store_type"(newStatus) {
      if (newStatus !== "your-allowed-status" && this.store_type == 2) {
        this.form.owner_id = "";
      }
    },
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`stores/masters?`)
        .then((masters) => {
          masters = masters.data;
          //Users
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.user_name + "  -  " + user.phone,
              value: user.id,
            });
          });
          // Franchisee
          masters.franchisee.forEach((frachisee) => {
            this.frachiseeItems.push({
              id: frachisee.id,
              text: frachisee.user_name + "  -  " + frachisee.phone,
              value: frachisee.id,
            });
          });
          //State
          masters.states.forEach((state) => {
            this.stateItems.push({
              id: state.id,
              text: state.name,
              value: state.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      console.log(this.data);
      await axios
        .post(`gst_data`, this.data)
        .then((response) => {
          let stores = response.data.data;
          let stateJurisdiction = stores.state_jurisdiction;
          this.form.business_name = stores.business_name;
          this.form.state_jurisdiction = stateJurisdiction
            .match(/^State - [^,]+/)[0]
            .split(" - ")[1];
          this.form.address = stores.address;
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
      this.getCityData();
    },
    async getCityData() {
      console.log("city", this.form.state_jurisdiction);
      const payload = {
        state: this.form.state_jurisdiction,
        country: "India",
      };
      console.log(payload);
      await axios
        .post(
          `https://countriesnow.space/api/v0.1/countries/state/cities`,
          payload
        )
        .then((response) => {
          this.cityItems = response.data.data;
          console.log(this.cityItems);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.store_users = [];
        this.form.user_ids.forEach((user_id) => {
          let store_user = {
            company_id: this.company.id,
            user_id: user_id,
          };
          this.form.store_users.push(store_user);
        });
        this.form.gst_no = this.data.id_number;

        await axios.post("/stores", this.form);
        // await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/stores");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
